export const urlConstants = {
    userSystemInfoUrl: "/api/UserSecurity/GetUsersSystemInfo/",
    userAllSystemInfoUrl: "/api/UserSecurity/GetAllSystemInfo/",
    registerPrincipleUrl: "/api/UserSecurity/RegisterPrincipal/",
    myWorkItemBasket: "/api/UserSecurity/GetMyWorkitems/",
    adminTreeGetWorkflows: "/api/UserSecurity/GetUserWorkflows/",
    adminTreeGetWorkQueues: "/api/Workflow/GetWorkFlowQueueStats/",
    adminTreeGetWorkItems: "/api/Workflow/GetWorkItems/",
    moveWorkItemURL: "/api/Workflow/MoveWorkItem/",
    GetBusinessAreas: "/api/UserSecurity/GetUserBusinessAreas/",
    GetDocumentTypes: "/api/UserSecurity/GetUserDocumentTypes/",
    GetDocumentTypesUploadURL: "/api/UserSecurity/GetUserWebUploadDocumentTypes/",
    GetIndexingFields: "/api/StorageObject/CopyDocumentTypeInfo/",
    GetDocumentTypeInfo: "/api/StorageObject/GetDocumentTypeInfo/",
    workItemBasketViewHistoryByWKID: "/api/WorkflowManager/GetWorkItemHistoryByWkID/",
    workItemBasketViewHistoryByFNID: "/api/WorkflowManager/GetWorkItemHistoryByFNID/",
    workItemBasketViewNotesByWKID: "/api/WorkflowManager/GetWorkItemNotesByWkID/",
    workItemBasketViewNotesByFNID: "/api/WorkflowManager/GetWorkItemNotesByFNID/",
    addNotes: "/api/WorkflowManager/AddWorkItemNote/",
    uploadFile: "/api/StorageObject/UpdateDocument/",
    updateDocumentType: "/api/Admin/UpdateDocumentType/",
    activateWorkItem: "/api/Workflow/UpdateWorkitemStatus",
    deleteWorkItem: "/api/Workflow/DeleteWorkItems",
    reAssignWorkItem: "/api/Workflow/AssignOrReleaseWorkItems",
    reAssignWorkItemWorkFlow: "/api/Workflow/AssignOrReleaseWorkItem",
    workItemIndexingFields: "/api/StorageObject/GetIndexingFieldsWithValues/",
    link: "/api/StorageObject/GetConsolidatedDocumentLink/",
    email: "/api/StorageObject/GetLinkEmailInfo/",
    sendEmail: "/api/StorageObject/EmailLink",
    viewDocumentWorkFlowHistoryURL: "/api/Workflow/GetWorkflowHistoryByDocID/",
    viewBatchWorkFlowHistoryURL: "/api/Workflow/GetWorkflowHistoryByBatchID/",
    addDocumentNotes: "/api/StorageObject/AddDocumentNote/",
    viewDocumentNotes: "/api/StorageObject/GetDocumentNotesByDocID/",
    viewWorkFlowNotes: "/api/Workflow/GetWorkItemNotesByDocID/",
    getWorkItemNotesByBatchIDURL: '/api/Workflow/GetWorkItemNotesByBatchID/',
    reAssignItemGpIds: "/api/UserSecurity/GetUsers/",
    alterItemGpIds: "/api/UserSecurity/GetUserAlterDocumentTypes",
    alterWorkItem: "/api/WorkflowManager/AlterDocumentType",
    retrievalSearchField: "/api/StorageObject/GetSearchFields/",
    retrievalSearchResults: "/api/StorageObject/SearchDocuments/",
    getDocumentProperties: "/api/StorageObject/GetDocumentProperties/",
    getUserPreferences: "/api/UserSecurity/GetUserSystemPreference/",
    saveUserPreferences: "/api/UserSecurity/SaveUserPreference",
    saveUserPreferencesColumns: "/api/UserSecurity/SaveUserPreferenceColumnData/",
    createDocument: "/api/StorageObject/CreateDocument/",
    getFile: "/api/StorageObject/GetUploadFileOptions/",
    addPages: "/api/StorageObject/AddPages/",
    addAttachments: "/api/StorageObject/AddAttachments/",
    exportExcel: "/api/StorageObject/ExportSearchResult",
    logOut: "/api/UserSecurity/SignOut",
    downloadWorkItem: "/api/WorkflowManager/GetDownloadURL/",
    deleteAttachmentItem: "/api/StorageObject/DeleteAttachment/",
    saveIndexingFields: "/api/StorageObject/SaveIndexingFields/",
    trafficCopQueueURL: "/api/Workflow/GetTrafficCopDocuments/",
    trafficCopBuinessLayersURL: "/api/UserSecurity/GetUserBusinessAreas/",
    trafficCopQueueStatusURL: "/api/Workflow/GetTrafficCopQueueStats/",
    trafficCopDocumentURL: "/api/Workflow/GetTrafficCopDocument/",
    trafficCopDocumentTypesURL: "/api/UserSecurity/GetTCUserDocumentTypes/",
    trafficCopDocumentReleaseItemURL: "/api/Workflow/AssignOrReleaseTrafficCopDocument/",
    trafficCopDocumentRecycleItemURL: "/api/Workflow/UpdateTrafficCopQueueType/",
    getAllSPABoxMapping: "/api/StorageObject/getAllSPABoxMapping/",
    getAllSPABox: "/api/StorageObject/GetAllSPABox/",
    modifySPABox: "/api/StorageObject/ModifySPABox/",
    documentsInfoURL: "/api/StorageObject/GetDocumentLinksInfo/",
    batchDocumentsURL: "/api/StorageObject/GetBatchDocuments/",
    batchHierarchyInfo: '/api/StorageObject/GetBatchHierarchyInfo/',
    batchSendToURL: '/api/Workflow/CreateSplitBatchWorkItem/',
    masterBatchInfo: '/api/StorageObject/GetMasterBatchInfo/',
    contactUsAndUserGuide: '/api/StorageObject/GetContactandGuidelines/',
    userPermissions: '/api/UserSecurity/GetUserSecurityProfile/',
    exportToExcelUrl: '/api/UserSecurity/ExportMyWorkitems/',
    getWorkItemURL: '/api/Workflow/GetWorkItem/',
    workItemLockUnLockURL: '/api/Workflow/UpdateWorkItemLock/',
    getGridColumnHeadersURL: '/api/Workflow/GetGridColumnHeaders/',
    lookupVendorMasterData: '/api/StorageObject/LookupVendorMasterData/',
    customCodeMappedIndexingFieldURL: '/api/StorageObject/GetMappedIndexingField/',
    autoAssignWorkItems: '/api/Workflow/AutoAssignWorkItems/',
    emailWI: "/api/Workflow/GetRequestorEmailInfo/",
    emailRequester: "/api/Workflow/EmailRequestor/",
    getIndexingFieldDropDown: '/api/StorageObject/GetIndexingFields/',
    getAutoAssignMappingRule: '/api/Workflow/GetAutoAssignRules/',
    addAutoAssignRule: '/api/Workflow/AddAutoAssignRule/',
    modifyAutoAssignMappingRule: '/api/Workflow/UpdateAutoAssignUser/',
    onDemandAutoCompleteURL: '/api/StorageObject/GetAutoComboValueLookup/',
    onVendorEmail: '/api/WorkflowManager/GetVendorEmailTemplateDetails/',
    routequeuebyindexingFields: '/api/Workflow/ValidateDestinationQueueByIdxField/',
    showMultiDocuments: '/api/StorageObject/ViewMultiDocument/',
    GetNextWorkItem: '/api/Workflow/GetNextWorkItemForDocumentViewer/',
    GetDocumentHistory: '/api/StorageObject/GetDocumentHistory/',
    SaveDocHistory: '/api/StorageObject/SaveDocHistory/',
    deleteDocument: '/api/StorageObject/DeleteDocument/',
    directRetrieval: '/api/StorageObject/DirectDocumentRetrieval/DirectRetrieval/',
    getVendorClassifications: "/api/StorageObject/GetVendorClassificationDetails/",
    saveVendorClassification: "/api/StorageObject/SaveVendorClassification/",
    deleteVendorClassificationData: "/api/StorageObject/DeleteVendorClassificationData/",
    getAbbyyLineItems: "/api/StorageObject/GetAbbyyLineItems/",
    saveAbbyyLineItems: "/api/StorageObject/SaveAbbyyLineItems/",
    deleteGLLineItem: "/api/StorageObject/DeleteGLLineItem/",
    getGLAutoComboValueLookup: "/api/StorageObject/GetGLAutoComboValueLookup/",
    getVendorClassificationAutoComboValueLookup: "/api/StorageObject/GetVendorClassificationAutoComboValueLookup/",
    getPaymentCode: "/api/StorageObject/GetPaymentCode/",
    savePaymentCode: "/api/StorageObject/ManagePaymentCode/",
    getEmailDelegation: "/api/StorageObject/GetEmailDelegation",
    upsertEmailDelegation: "/api/StorageObject/UpsertEmailDelegation",
    deleteEmailDelegation: "/api/StorageObject/DeleteEmailDelegation"
};